import React from "react";

import Presentation from "./presentation";

const component = props => {
	const {
		fanRankAmount,
		handleFanRankAmountChange,
		userProfile,
		errorMsg,
		type,
		defaultMsg
	} = props;

	return (
		<Presentation
			defaultMsg         = { defaultMsg }
			errorMsg           = { errorMsg }
			fanRankAmount      = { fanRankAmount }
			handleAmountChange = { handleFanRankAmountChange }
			type               = { type }
			userProfile        = { userProfile }
		/>

	);
};

export default component;
